import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import {
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
} from '@fortawesome/pro-light-svg-icons';

export enum ChevronState {
  UP = 'up',
  LEFT = 'left',
  DOWN = 'down',
  RIGHT = 'right',
}

@Component({
  selector: 'ct-lib-rotating-chevron, app-rotating-chevron',
  templateUrl: './rotating-chevron.component.html',
  styleUrls: ['./rotating-chevron.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FaIconComponent],
})
export class RotatingChevronComponent {
  protected readonly ChevronState = ChevronState;

  readonly toggle = input<boolean>(false);
  readonly baseState = input<ChevronState>(ChevronState.DOWN);
  readonly toggledState = input<ChevronState>(ChevronState.UP);
  readonly large = input<boolean>(false);
  readonly size = input<'lg' | undefined>(undefined);

  readonly currentState = computed(() =>
    this.toggle() ? this.toggledState() : this.baseState()
  );

  readonly iconSize = computed(() =>
    this.large() || this.size() === 'lg' ? 'lg' : undefined
  );

  readonly baseIcon = computed(() => {
    switch (this.baseState()) {
      case ChevronState.UP:
        return faChevronUp;
      case ChevronState.LEFT:
        return faChevronLeft;
      case ChevronState.DOWN:
        return faChevronDown;
      case ChevronState.RIGHT:
        return faChevronRight;
    }
  });

  readonly rotationClass = computed(() => {
    if (!this.toggle()) {
      return '';
    }

    const base = this.baseState();
    const target = this.toggledState();

    if (
      (base === ChevronState.UP && target === ChevronState.DOWN) ||
      (base === ChevronState.DOWN && target === ChevronState.UP)
    ) {
      return 'flipX';
    }

    if (
      (base === ChevronState.LEFT && target === ChevronState.RIGHT) ||
      (base === ChevronState.RIGHT && target === ChevronState.LEFT)
    ) {
      return 'flipY';
    }

    if (base === ChevronState.UP) {
      return target === ChevronState.LEFT ? 'counterClockWise' : 'clockWise';
    }
    if (base === ChevronState.DOWN) {
      return target === ChevronState.LEFT ? 'clockWise' : 'counterClockWise';
    }
    if (base === ChevronState.LEFT) {
      return target === ChevronState.UP ? 'clockWise' : 'counterClockWise';
    }
    if (base === ChevronState.RIGHT) {
      return target === ChevronState.UP ? 'counterClockWise' : 'clockWise';
    }

    return '';
  });
}
